import { useChatState } from "../../context/context";
import React, { useState } from "react";
import MessageSection from "./MessageSection";
import UsersSection from "./UsersSection";
const Chat = () => {
  const [fetchAgain, setFetchAgain] = useState(false);
  const { user } = useChatState();

  console.log(user, "user");
  return (
    <>
      <title>Community | Chats</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="card"
                  id="chat3"
                  style={{ borderRadius: "15px" }}
                >
                  <div className="card-body">
                    <div className="row">
                      {/* Users List Section */}
                      {user && <UsersSection fetchAgain={fetchAgain} />}

                      {/* Message Section */}
                      {user && (
                        <MessageSection
                          fetchAgain={fetchAgain}
                          setFetchAgain={setFetchAgain}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Chat;
